import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * [장비등록 > 관리대상등록] 가상화센터 목록 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getVirtualCenterList() {
    return axios.get(`${baseUrl}/settings/device-registration-vms/get-virtual-center-list.do`);
  },
  /**
   * [장비등록 > 관리대상등록] 최근 3일이내 등록된 장비 갯수 조회
   * @author jeee12
   * @return {[type]} [description]
   */
  getRecentRegisteredDeviceCount(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/get-recent-registered-device-count.do`, params);
  },
  /**
   * [장비등록 > 관리대상등록] 가상화 장비종류별 장비목록 조회
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getVirtualObjList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/get-virtual-obj-list.do`, params);
  },
  /**
   * [장비등록 > 가상화 모델링] 가상화 모델링 목록을 조회
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getVirtualModelingList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/get-virtual-modeling-list.do`, params);
  },
  /**
 * [장비등록 > 가상화 모델링] 가상화 모델링 목록을 추가
 * @author najongdang
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  insertVirtualModeling(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/insert-virtual-modeling.do`, params);
  },
  /**
   * [장비등록 > 가상화 모델링] RHEV 하이퍼바이저에 대한 가상화 모델링 추가
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  insertRhevVirtualModeling(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/insert-rhev-virtual-modeling.do`, params);
  },
  /**
 * [장비등록 > 가상화 모델링] 가상화 모델링 목록을 삭제
 * @author najongdang
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  deleteVirtualModelingList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/delete-virtual-modeling-list.do`, params);
  },
  /**
 * [장비등록 > 가상화 모델링] 가상화 모델링 목록을 수정
 * @author najongdang
 * @param  {[type]} params [description]
 * @return {[type]}        [description]
 */
  updateVirtualModelingList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/update-virtual-modeling-list.do`, params);
  },
  /**
   * [장비등록 > 관리대상등록] 가상화 장비 목록 수정
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  updateVirtualDeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/update-virtual-device-list.do`, params);
  },
  /**
   * [장비등록 > 관리대상등록] 가상화 장비 목록 삭제
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  deleteVirtualDeviceList(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/delete-virtual-device-list.do`, params);
  },
  /**
   * [장비등록 > 가상화 모델링] 가상화 모델링 수행
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  executeAutodiscovery(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/execute-autodiscovery.do`, params);
  },
  /**
   * [장비등록 > 가상화 모델링] 가상화 모델링 추가/수정시 가상화센터명, 접속정보 중복체크
   * @author jeee12
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  checkVirtualcenterValidation(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/check-virtualcenter-validation.do`, params);
  },
  /**
   * [장비등록 > 가상화 > VM 관리] VM 정보를 수정한다 ( 메인 사용자, 만료날짜 )
   * @author Song
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  setVirtualVmSettingInfo(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/set-virtual-vm-setting-info.do`, params);
  },
  /**
   * [장비등록 > 가상화 > VM 관리] VM을 폐기한다
   * @author najongadng
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  discardRealVm(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/discard-real-vm.do`, params);
  },
  /**
   * [장비등록 > 가상화 > 템플릿 관리] 템플릿 정보를 수정한다 ( 템플릿 제어 IP ,ID, 비밀번호 )
   * @author najongdang
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  setVirtualTemplateSettingInfo(params) {
    return axios.post(`${baseUrl}/settings/device-registration-vms/set-virtual-template-setting-info.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/settings/common/device-registration-vms.js